import { getAccessToken } from "api/common";
import { registerAxiosAuthInterceptor } from "app/Auth/axiosAuthInterceptor";
import axios from "axios";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { formatErrorMessage } from "logging/helpers";

axios.defaults.headers.post["Content-Type"] = "application/json";

export const axiosClient = axios.create();

axiosClient.interceptors.request.use(async (config) => {
  try {
    const accessToken = await getAccessToken();
    // eslint-disable-next-line no-param-reassign -- Interceptor function
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  } catch (error) {
    /**
     * We do NOT reload the page, as throwing an error here already sends
     * you to the "Logg inn" page. Reloading the page causes issues with
     * tests, as infinitely reloading the page hangs vitest.
     * However, reloading the page at dropsHttpClient.ts is still necessary.
     */
    log(LogLevel.error, "axiosClient.interceptors", formatErrorMessage(error));
    throw error;
  }
});

registerAxiosAuthInterceptor(axiosClient);
